import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, mergeMap } from "rxjs/operators";
import { CommonService } from "@services";
import { getCountries, getCountriesError, getCountriesSuccess } from "./countries.actions";

@Injectable()
export class CountriesEffects {
  public readonly getCountries$ = createEffect(() =>
    this._actions$.pipe(
      ofType(getCountries),
      mergeMap(() =>
        this._commonService.getCountries().pipe(
          map((response) => getCountriesSuccess({ countries: response.data })),
          catchError((error) => of(getCountriesError({ error }))),
        ),
      ),
    ),
  );

  constructor(
    private _actions$: Actions,
    private _commonService: CommonService,
  ) {}
}
